<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="Trucking-Movement-Update-Main">
    <div class="left-container" :class="[closeLeftTab ? 'left-tab-close' : '']">
      <div class="arrow-button">
        <img
          :style="{
            transform: `${
              closeLeftTab ? `scaleX(-1)`
              : !closeLeftTab ? `scaleX(1)`
              : closeLeftTab ? `rotate(90deg) scaleX(-1)`
              : `rotate(90deg) scaleX(1)`
            }`,
          }"
          @click="closeLeftTab = !closeLeftTab"
          src="https://img.icons8.com/material-rounded/96/000000/double-left.png"
        />
      </div>
      <div class="left-container-content" :style="{ display: closeLeftTab ? 'none' : '' }">
        <InputQuery
          placeholder="Journey #"
          :items="journeyList"
          itemKey="Journey #"
          :selectedObject.sync="selectedJourney"
        />
        <button @click="getJourneyDetails()">Refresh</button>
        <button :disabled="disablePostTrip" @click="postTrip" >Post Trips</button>
        <button :disabled="disableUndoPostTrip" @click="undoPostTrip">Undo-Post</button>
        <button @click="pointStop(true)">Set Point Stop</button>
        <button @click="pointStop(false)">Remove Point Stop</button>
        <button @click="combineTrip(true)">Set Combine Trip</button>
        <button @click="combineTrip(false)">Remove Combine Trip</button>
      </div>
      <div class="left-container-bottom-content" :style="{ display: closeLeftTab ? 'none' : '' }">
        <div class="tab-header">
          <div :class="['tab-box', { selected: detailsCommissionSelected }]" @click="tabChanged('detcom')">
            Details / Commission
          </div>
          <div :class="['tab-box', { selected: expensesDocumentsSelected }]" @click="tabChanged('expdoc')">
            Expenses / Documents
          </div>
        </div>
      </div>
    </div>
    <div class="right-container">
      <div class="top-container">
        <div class="top-left-container">
          <div class="details-content">
            <div class="details-title"> Date </div>
            <div class="details-colon"> : </div>
            <div class="details-result"> {{ date }} </div>
            <div class="details-title" style="margin-left: 50px"> Comm </div>
            <div class="details-colon"> : </div>
            <div class="details-result"> {{ comm }} </div>
          </div>
          <div class="details-content">
            <div class="details-title"> Driver </div>
            <div class="details-colon"> : </div>
            <div class="details-result"> {{ driver }} </div>
          </div>
          <div class="details-content">
            <div class="details-title"> Attendant </div>
            <div class="details-colon"> : </div>
            <div class="details-result"> {{ attendant }} </div>
          </div>
          <div class="details-content">
            <div class="details-title"> Attendant2 </div>
            <div class="details-colon"> : </div>
            <div class="details-result"> {{ attendant2 }} </div>
          </div>
          <div class="details-content">
            <div class="details-title"> Lorry </div>
            <div class="details-colon"> : </div>
            <div class="details-result"> {{ lorry }} </div>
          </div>
        </div>
        <div class="top-middle-container">
          <div class="comm-content">
            <div class="comm-position">Driver</div>
            <Input placeholder="Basic Comm" textType="number" :inputValue.sync="driverbasiccomm" :isDisabled="true" /> +
            <Input placeholder="Ad Hoc" textType="number" :inputValue.sync="driveradhoc" :isDisabled="true" /> +
            <Input placeholder="Others" textType="number" :inputValue.sync="driverothers" :isDisabled="true" /> =
            <Input placeholder="Total" textType="number" :inputValue.sync="drivertotal" :isDisabled="true" />
          </div>
          <div class="comm-content">
            <div class="comm-position">Attendant</div>
            <Input placeholder="Basic Comm" textType="number" :inputValue.sync="attendantbasiccomm" :isDisabled="true" /> +
            <Input placeholder="Ad Hoc" textType="number" :inputValue.sync="attendantadhoc" :isDisabled="true" /> +
            <Input placeholder="Others" textType="number" :inputValue.sync="attendantothers" :isDisabled="true" /> =
            <Input placeholder="Total" textType="number" :inputValue.sync="attendanttotal" :isDisabled="true" />
          </div>
          <div class="comm-content">
            <div class="comm-position">Attendant2</div>
            <Input placeholder="Basic Comm" textType="number" :inputValue.sync="attendant2basiccomm" :isDisabled="true" /> +
            <Input placeholder="Ad Hoc" textType="number" :inputValue.sync="attendant2adhoc" :isDisabled="true" /> +
            <Input placeholder="Others" textType="number" :inputValue.sync="attendant2others" :isDisabled="true" /> =
            <Input placeholder="Total" textType="number" :inputValue.sync="attendant2total" :isDisabled="true" />
          </div>
        </div>
      </div>
      <div class="middle-container">
        <TableBox v-if="showTripList" title="Trips" :tableData="tripList" :selectedRow.sync="selectedTrip" :rowHeight="20" :dataType="tripListDataType" :hideColumns="hideTripListColumn" :maxSelection="-1" />
      </div>
      <div v-if="detailsCommissionSelected" class="bottom-container">
        <div class="bottom-left-container">
          <BoxContainer title="Journey Details" :isCollapsible="false">
            <div class="bottom-left-boxcontainer">
              <div class="bottom-left-boxcontainer-left">
                <Input placeholder="Est KM" textType="number" :isDisabled="true" :inputValue.sync="estKM" />
                <Input style="visibility: hidden" :isDisabled="true" />
                <Input placeholder="Est Toll Cost" textType="number" :isDisabled="true" :inputValue.sync="estTollCost"  />
                <Input placeholder="Est Fuel Cost" textType="number" :isDisabled="true" :inputValue.sync="EstFuelCost" />
                <InputQuery
                  placeholder="Driver"
                  :items="driverList"
                  itemKey="Driver Code"
                  :selectedObject.sync="selectedDriver"
                  :isDisabled="!journeyDetailsEditMode"
                />
                <InputQuery
                  placeholder="Attendant"
                  :items="attendantList"
                  itemKey="Attendant Code"
                  :selectedObject.sync="selectedAttendant"
                  :isDisabled="!journeyDetailsEditMode"
                />
              </div>
              <div class="bottom-left-boxcontainer-right">
                <Input placeholder="Start Meter" textType="number" :isDisabled="!journeyDetailsEditMode" :inputValue.sync="startMeter" validator="positiveInteger" />
                <Input placeholder="End Meter" textType="number" :isDisabled="!journeyDetailsEditMode" :inputValue.sync="endMeter" validator="positiveInteger" />
                <Input placeholder="Toll Cost" textType="number" :isDisabled="!journeyDetailsEditMode" :inputValue.sync="tollCost" validator="positiveCurrency" />
                <Input placeholder="Fuel Cost" textType="number" :isDisabled="!journeyDetailsEditMode" :inputValue.sync="fuelCost" validator="positiveCurrency" />
                <InputQuery
                  placeholder="Comission Code"
                  :items="commisionList"
                  itemKey="Com Code"
                  :selectedObject.sync="selectedCommision"
                  :isDisabled="!journeyDetailsEditMode"
                />
                <InputQuery
                  placeholder="Attendant2"
                  :items="attendantList"
                  itemKey="Attendant Code"
                  :selectedObject.sync="selectedAttendant2"
                  :isDisabled="!journeyDetailsEditMode"
                />
                <div class="boxcontainer-right-button">
                  <button v-if="journeyDetailsEditMode" @click="saveJourneyDetails">Save</button>
                  <button v-if="journeyDetailsEditMode" @click="journeyDetailsEditMode = false"
                    >Cancel</button
                  >
                  <button
                    v-if="!journeyDetailsEditMode"
                    @click="journeyDetailsEditMode = true"
                    :disabled="disableUpdateDetail"
                    >Edit</button
                  >
                </div>
              </div>
            </div>
          </BoxContainer>
        </div>
        <div class="bottom-driver-attendant-commision">
          <div class="add-edit-delete-button">
            <button :disabled="disableAddOtherComm" @click="driverAttendantCommAddClick">Add</button>
            <button :disabled="disableDeleteOtherComm" @click="deleteDriverAttendantComm">Delete</button>
          </div>
          <div class="driver-attendant-table">
            <TableBox v-if="showDriverAttendantCommData" title="Driver/Attendant Commission" :tableData.sync="driverAttendantCommData" :dataType="driverAttendantCommDataType" :rowHeight="20" :selectedRow.sync="selectedDriverAttendantComm" :hideColumns="hideDriverAttendantCommColumn" :hideBottomBlock="true" />
          </div>
        </div>
      </div>
      <div v-if="expensesDocumentsSelected" class="bottom-container">
        <div class="bottom-middle-container">
          <div class="add-edit-delete-button">
            <button :disabled="disableExpenses || true">Edit</button>
          </div>
          <div class="journey-expenses-table">
            <TableBox title="Journey Claims/Expenses" :tableData="journeyClaimsExpensesData" :rowHeight="20" :hideColumns="hideJourneyClaimsExpensesColumn" />
          </div>
        </div>
        <div class="bottom-right-container">
          <div class="add-edit-delete-button">
            <button :disabled="disableDocument || true">Add</button>
            <button :disabled="disableDocument || true">Delete</button>
          </div>
          <div class="document-table">
            <TableBox v-if="showDocumentsData" title="Documents" :tableData.sync="documentsData" :rowHeight="20" :hideColumns="hideDocumentsColumn" />
          </div>
        </div>
      </div>
    </div>

    <PopupV2 :show="showDriverAttendantCommPopup" :buttons="driverAttendantCommPopupButton" title="Add Driver/Attendant Commission" @buttonClicked="addDriverAttendantComm" width="550px" >
      <div style="width: 100%">
        <TableBox v-if="showDriverAttendantCommPopupTable" title="Comm Code" :tableData.sync="fixedCommCodeData" :rowHeight="20" :columnWidth="fixedCommCodeDataWidth" :dataType="fixedCommCodeDataType" :selectedRow.sync="selectedFixedCommCode" />
      </div>
    </PopupV2>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data: function () {
    return {
      closeLeftTab: false,
      detailsCommissionSelected: true,
      expensesDocumentsSelected: false,
      disablePostTrip: false,
      disableUndoPostTrip: false,
      disableAddOtherComm: false,
      disableDeleteOtherComm: false,
      disableUpdateDetail: false,
      disableExpenses: false,
      disableDocument: false,

      journeyList: [],
      selectedJourney: {},
      journeyDetails: {},
      tripList: [],
      selectedTrip: [],
      tripListDataType: {
        'Qty': 'number',
        // 'KG': 'number',
        // 'M3': 'number',
        'Drv Comm': 'currency',
        'Depart Time': 'date',
        'Arrival Time': 'date',
        'AdHoc Comm': 'currency',
        'Attn Comm': 'currency',
        'Attn AdHoc Comm': 'currency',
        'Trip Revenue': 'currency',
        'EXP': 'currency',
        'TOL': 'currency',
        'AttnEXP': 'currency',
        'AttnTOL': 'currency',
        'Other Comm': 'currency',
        'Attn2 Comm': 'currency',
        'Attn2 AdHoc': 'currency',
        'Attn2EXP': 'currency',
        'Attn2TOL': 'currency'
      },
      showTripList: true,
      hideTripListColumn: [ 'estdeparturedate', 'estarrivaldate', 'pointstop', 'legind', 'packagelength', 'packagewidth', 'packageheight', 'tmsjino', 'ind', 'entryind', 'jobno', 'seqno', 'journeyguid'],

      //top container journey details
      date: '        ', //empty space to fix position
      comm: '',
      driver: '',
      attendant: '',
      attendant2: '',
      lorry: '',

      //top container driver and attendant comm
      driverbasiccomm: '0.00',
      driveradhoc: '0.00',
      driverothers: '0.00',
      drivertotal: '0.00',
      attendantbasiccomm: '0.00',
      attendantadhoc: '0.00',
      attendantothers: '0.00',
      attendanttotal: '0.00',
      attendant2basiccomm: '0.00',
      attendant2adhoc: '0.00',
      attendant2others: '0.00',
      attendant2total: '0.00',

      //journey details
      commisionList: [],
      selectedCommision: {},
      originalSelectedCommision: {},
      driverList: [],
      selectedDriver: {},
      originalSelectedDriver: {},
      attendantList: [],
      selectedAttendant: {},
      originalSelectedAttendant: {},
      selectedAttendant2: {},
      originalSelectedAttendant2: {},
      estKM: '',
      estTollCost: '',
      EstFuelCost: '',
      startMeter: '',
      endMeter: '',
      tollCost: '',
      fuelCost: '',

      //journey claims / expenses
      journeyClaimsExpensesData: [],
      hideJourneyClaimsExpensesColumn: [ 'tmsjino' ],
      journeyDetailsEditMode: false,

      //documents
      documentsData: [],
      showDocumentsData: true,
      hideDocumentsColumn: [ 'doccode', 'doctype', 'documentguid', 'image1', 'tmsjino' ],

      //driver attendant commission
      driverAttendantCommData: [], 
      showDriverAttendantCommData: true,
      driverAttendantCommDataType: { 'Drv Other Comm': 'currency', 'Attn Other Comm': 'currency' },
      selectedDriverAttendantComm: [],
      hideDriverAttendantCommColumn: [ 'ind', 'journeyothguid', 'jitmsseqno', 'tmsjino' ],
      fixedCommCodeData: [],
      fixedCommCodeDataTemp: [],
      fixedCommCodeDataWidth: [100, 230, 100, 100],
      fixedCommCodeDataType: { 'Driver': 'currency', 'Attendant': 'currency' },
      selectedFixedCommCode: [],
      showDriverAttendantCommPopup: false,
      showDriverAttendantCommPopupTable: false,
      driverAttendantCommPopupButton: [ { text: 'Add'}, { text: 'Cancel' } ],
    };
  },
  props: {},
  methods: {
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      //normally using menu to control sas but this page isnt using left menu
      const sasControl = await this.$apiCallV2('/SASControl/GetSASControlAccess?system=TMS&page=Movement Update');
      if (sasControl) {
        const cmdPost = sasControl.find((sas) => sas.Control === 'cmdPost');
        if (cmdPost) {
          this.disablePostTrip = true;
        }

        const cmdReversePost = sasControl.find((sas) => sas.Control === 'cmdReversePost');
        if (cmdReversePost) {
          this.disableUndoPostTrip = true;
        }

        const cmdAdd = sasControl.find((sas) => sas.Control === 'cmdAdd');
        if (cmdAdd) {
          this.disableAddOtherComm = true;
          this.disableDeleteOtherComm = true;
        }

        const cmdUpdate = sasControl.find((sas) => sas.Control === 'cmdUpdate');
        if (cmdUpdate) {
          this.disableUpdateDetail = true;
        }

        const cmdExpenses = sasControl.find((sas) => sas.Control === 'cmdExpenses');
        if (cmdExpenses) {
          this.disableExpenses = true;
        }

        const cmdAddDoc = sasControl.find((sas) => sas.Control === 'cmdAddDoc');
        if (cmdAddDoc) {
          this.disableDocument = true;
        }
      }

      this.$fullscreenLoading('');
    },

    tabChanged(tab) {
      this.showDriverAttendantCommData = false;
      this.showDocumentsData = false;
      if (tab === 'detcom') {
        this.detailsCommissionSelected = true;
        this.expensesDocumentsSelected = false;
      } else {
        this.detailsCommissionSelected = false;
        this.expensesDocumentsSelected = true;
      }
      this.$nextTick(() => { //need this because the table data wont changed after switching the tab and the table data will be same
        this.showDriverAttendantCommData = true;
        this.showDocumentsData = true;
      });
    },

    async getDropdownData() {
      this.$fullscreenLoading('Getting Data');
      //promise to get all data
      const dropdownDataPromises = [];
      let promisesFulfilled = 0;

      dropdownDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'TMSJOURNEY' }).then((result) => {
          this.journeyList = result;
          this.$topLoading(++promisesFulfilled / dropdownDataPromises.length);
        })
      );

      dropdownDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'LORRYCOMISSION' }).then((result) => {
          this.commisionList = result;
          this.$topLoading(++promisesFulfilled / dropdownDataPromises.length);
        })
      );

      dropdownDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'ATTENDANT', module: 'TMS' }).then((result) => {
          this.attendantList = result;
          this.$topLoading(++promisesFulfilled / dropdownDataPromises.length);
        })
      );

      dropdownDataPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'DRIVERNO', module: 'TMS' }).then((result) => {
          this.driverList = result;
          this.$topLoading(++promisesFulfilled / dropdownDataPromises.length);
        })
      );

      await Promise.allSettled(dropdownDataPromises);
      this.$fullscreenLoading();
    },

    async getJourneyDetails() {
      this.$fullscreenLoading('Getting Journey Data');

      this.clearData();
      // this.showTripList = false;
      const journeyDetailsTemp = await this.$apiCallV2('/Master/GetDetailsMaster', { masterfile: 'TMSMOVEMENTUPDATEDETAILS', recordid: this.selectedJourney['Journey #'] });
      if (journeyDetailsTemp) {
        this.journeyDetails = journeyDetailsTemp['TMSJIHdr'];
        this.date = this.journeyDetails['dateissued'],
        this.comm = this.journeyDetails['comcode'];
        this.driver = `${this.journeyDetails['driver']} ${this.journeyDetails['drivername']}`;
        this.attendant = `${this.journeyDetails['attendant'] ?? ''} ${this.journeyDetails['attnname'] ?? ''}`;
        this.attendant2 = `${this.journeyDetails['attendant2'] ?? ''} ${this.journeyDetails['attn2name'] ?? ''}`;
        this.lorry = `${this.journeyDetails['vehiclecode']} ${this.journeyDetails['lorryno']}`;
        this.tripList = this.journeyDetails['TMSJIDetails'];
        this.estKM = this.journeyDetails['esttotalkilometer'] ?? '0';
        this.startMeter = this.journeyDetails['startmeter'] ?? '0';
        this.endMeter = this.journeyDetails['endmeter'] ?? '0';
        this.estTollCost = this.journeyDetails['esttollcost'] ?? '0.00';
        this.tollCost = this.journeyDetails['acttollcost'] ?? '0.00';
        this.EstFuelCost = this.journeyDetails['estfuelcost'];
        this.fuelCost = this.journeyDetails['actfuelcost'];
        this.selectedDriver = this.driverList.getSelected(this.journeyDetails['driver'], 'Driver Code');
        this.originalSelectedDriver = this.driverList.getSelected(this.journeyDetails['driver'], 'Driver Code');
        this.selectedCommision = this.commisionList.getSelected(this.journeyDetails['comcode'], 'Com Code');
        this.originalSelectedCommision = this.commisionList.getSelected(this.journeyDetails['comcode'], 'Com Code');
        if (this.journeyDetails['attendant']) {
          this.selectedAttendant = this.attendantList.getSelected(this.journeyDetails['attendant'], 'Attendant Code');
          this.originalSelectedAttendant = this.attendantList.getSelected(this.journeyDetails['attendant'], 'Attendant Code');
        }
        if (this.journeyDetails['attendant2']) {
          this.selectedAttendant2 = this.attendantList.getSelected(this.journeyDetails['attendant2'], 'Attendant Code');
          this.originalSelectedAttendant2 = this.attendantList.getSelected(this.journeyDetails['attendant2'], 'Attendant Code');
        }

        if (this.journeyDetails['TMSJIOtherComm']) {
          this.driverAttendantCommData = this.journeyDetails['TMSJIOtherComm'];
        }

        if (this.journeyDetails['TMSJIExpenses']) {
          this.journeyClaimsExpensesData = this.journeyDetails['TMSJIExpenses'];
        }

        if (this.journeyDetails['TMSJIDocuments']) {
          this.documentsData = this.journeyDetails['TMSJIDocuments'];
        }

        this.fixedCommCodeDataTemp = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'FIXEDCOMMCODE', jobtype: this.comm });
        await this.GetDriverRevenue();

        //lastly add the icon in
        this.tripList.forEach(t => {
            if (t['ind'] == 'F') {
              t['#'] = `<img src="https://dsmlib.logistics.systems/Icons/GreenTick.png" width="15" height="15">${t['#']}`;
            } else if (t['ind'] == 'P') {
              t['#'] = `<img src="https://dsmlib.logistics.systems/Icons/GreenPaid.png" width="15" height="15">${t['#']}`;
            } else if (t['ind'] == 'C') {
              t['#'] = `<img src="https://dsmlib.logistics.systems/Icons/Cancel.png" width="15" height="15">${t['#']}`;
            } else if (t['ind'] == 'N') {
              t['#'] = `<img src="https://dsmlib.logistics.systems/Icons/transparent.png" width="15" height="15">${t['#']}`;
            }

            if (t['Combine Trip #'] != '' && t['Combine Trip #'] != '0') {
              t['Consignment #'] = `<img src="https://dsmlib.logistics.systems/Icons/GreenPlus.png" width="15" height="15">${t['Consignment #']}`;
            } else {
              t['Consignment #'] = `<img src="https://dsmlib.logistics.systems/Icons/transparent.png" width="15" height="15">${t['Consignment #']}`;
            }

            if (t['pointstop'] == '1') {
              t['Drop Off'] = `<img src="https://dsmlib.logistics.systems/Icons/BlueDot.png" width="15" height="15">${t['Drop Off']}`;
            } else {
              t['Drop Off'] = `<img src="https://dsmlib.logistics.systems/Icons/transparent.png" width="15" height="15">${t['Drop Off']}`;
            }
        });
      }

      this.$fullscreenLoading();
    },

    async GetDriverRevenue() {
      this.$fullscreenLoading('Getting Driver and Attendant Commission');

      const postJson = {
        tmsjino: this.selectedJourney['Journey #'],
        driver: this.journeyDetails['driver'],
        attendant: this.journeyDetails['attendant'],
        attendant2: this.journeyDetails['attendant2'],
        trips: this.tripList.map(t => {
          return {
            ind: t['ind'],
            journeyguid: t['journeyguid']
          };
        })
      };
      const getTMSDriverRevenue = await this.$apiCallV2('/TruckingMovementUpdate/GetTMSDriverRevenue', postJson);

      this.showTripList = false;
      if (getTMSDriverRevenue && getTMSDriverRevenue['triprevenue'].length > 0) {
        getTMSDriverRevenue['triprevenue'].forEach(tr => {
          let trip = this.tripList.find(f => f['journeyguid'] == tr['journeyguid']);
          trip['Drv Comm'] = tr['drvcomm'];
          trip['Attn Comm'] = tr['attncomm'];
          trip['Attn2 Comm'] = tr['attn2comm'];
          trip['Trip Revenue'] = tr['triprevenue'];
        });
      }

      this.tripList.forEach(tl => {
        this.driverbasiccomm = Number(this.driverbasiccomm) + Number(tl['Drv Comm']);
        this.attendantbasiccomm = Number(this.attendantbasiccomm) + Number(tl['Attn Comm']);
        this.attendant2basiccomm = Number(this.attendant2basiccomm) + Number(tl['Attn2 Comm']);
      });
      this.driverbasiccomm = this.driverbasiccomm.toFixed(2);
      this.attendantbasiccomm = this.attendantbasiccomm.toFixed(2);
      this.attendant2basiccomm = this.attendant2basiccomm.toFixed(2);
      if (this.driverAttendantCommData && this.driverAttendantCommData.length > 0)
      {
        this.driverAttendantCommData.forEach(fe => {
          // eslint-disable-next-line prefer-const -- need to update findJitms column 
          let findJitms = this.tripList.find(f => f['seqno'] == fe['jitmsseqno']);
          if (findJitms) {
            findJitms['Other Comm'] = (Number(findJitms['Other Comm']) + Number(fe['Drv Other Comm'])).toFixed(2);
          }
        });
        this.driverothers = Number(this.driverAttendantCommData.map(m => Number(m['Drv Other Comm'])).reduce((sum, value) => sum + value)).toFixed(2);
        this.attendantothers = Number(this.driverAttendantCommData.map(m => Number(m['Attn Other Comm'])).reduce((sum, value) => sum + value)).toFixed(2);
      }
      
      if (this.journeyDetails['attendant2']) {
        this.attendant2others = this.attendantothers;
      }

      //get total
      this.drivertotal = (Number(this.driverbasiccomm) + Number(this.driveradhoc) + Number(this.driverothers)).toFixed(2);
      this.attendanttotal = (Number(this.attendantbasiccomm) + Number(this.attendantadhoc) + Number(this.attendantothers)).toFixed(2);
      this.attendant2total = (Number(this.attendant2basiccomm) + Number(this.attendant2adhoc) + Number(this.attendant2others)).toFixed(2);

      this.$nextTick(() => {
        this.showTripList = true;
      });
      this.$fullscreenLoading();
    },

    clearData() {
      this.journeyDetails = {};
      this.date = '         '; //empty space to fix position
      this.comm = '';
      this.driver = '';
      this.attendant = '';
      this.attendant2 = '';
      this.lorry = '';
      this.selectedDriver = {};
      this.selectedAttendant = {};
      this.originalSelectedAttendant = {};
      this.selectedAttendant2 = {};
      this.originalSelectedAttendant2 = {};
      this.selectedCommision = {};

      this.tripList = [];
      this.selectedTrip = [];
      this.driverAttendantCommData = [];
      this.selectedDriverAttendantComm = [];
      this.journeyClaimsExpensesData = [];
      this.documentsData = [];

      this.estKM = '';
      this.estTollCost = '';
      this.EstFuelCost = '';
      this.startMeter = '';
      this.endMeter = '';
      this.tollCost = '';
      this.fuelCost = '';

      this.driverbasiccomm = '0.00';
      this.driveradhoc = '0.00';
      this.driverothers = '0.00';
      this.drivertotal = '0.00';
      this.attendantbasiccomm = '0.00';
      this.attendantadhoc = '0.00';
      this.attendantothers = '0.00';
      this.attendanttotal = '0.00';
      this.attendant2basiccomm = '0.00';
      this.attendant2adhoc = '0.00';
      this.attendant2others = '0.00';
      this.attendant2total = '0.00';
    }, 

    async addDriverAttendantComm(buttonText) {
      if (buttonText === 'Cancel') {
        this.showDriverAttendantCommPopup = false;
      } else if (buttonText === 'Add') {
        if (!this.selectedFixedCommCode) {
          this.$showAlert('error', 'No Comm Code Selected', 'Please select a comm code to add');
          return;
        }

        const postData = {
          tmsjino: this.selectedJourney['Journey #'], 
          comcode: this.comm,
          jobno: this.selectedTrip[0]['jobno'],
          cn: this.removeImgTag(this.selectedTrip[0]['Consignment #']),
          fixcomcode: this.selectedFixedCommCode[0]['Fixed Comm Code'],
          jitmsseqno: this.selectedTrip[0]['seqno'],
          attendant: this.journeyDetails['attendant'],
          action: 'N',
          ind: this.selectedTrip[0]['ind']
        };

        const result = await this.$apiCallV2('/TruckingMovementUpdate/TMSMovementUpdateUpdateDrvAttnOthComm', postData);
        if (result[0]['Results'] != '0') {
          this.$showAlert('error', 'Add Failed', `Unable to add commission due to ${result[0]['ErrMsg']}`);
          return;
        }
        this.showDriverAttendantCommPopup = false;
        await this.getJourneyDetails();
      }
    }, 

    async deleteDriverAttendantComm() {
      if (this.selectedDriverAttendantComm.length == 0) {
        this.$showAlert('warning', 'No Commission Selected', 'Please select a commission code to delete');
        return;
      }
      const confirm = await this.$showAlert('warning', 'Delete Other Commission', `Are you sure you want to delete ${this.selectedDriverAttendantComm[0]['Fixed Comm Code']}?`, 
        [{ text: 'Yes', color: 'red', textColor: 'white' }, { text: 'No', color: 'lightgray', textColor: 'black' }]
      );
      if (confirm == 'No') {
        return;
      }
      const postData = {
        tmsjino: this.selectedJourney['Journey #'],
        fixcomcode: this.selectedDriverAttendantComm[0]['Fixed Comm Code'], 
        ind: this.selectedDriverAttendantComm[0]['ind'],
        jitmsseqno: this.selectedDriverAttendantComm[0]['jitmsseqno'],
        action: 'D'
      };

      const result = await this.$apiCallV2('/TruckingMovementUpdate/TMSMovementUpdateUpdateDrvAttnOthComm', postData);
      if (result[0]['Results'] != '0') {
        this.$showAlert('error', 'Delete Failed', `Unable to delete commission due to ${result[0]['ErrMsg']}`);
      }
      await this.getJourneyDetails();
    },

    driverAttendantCommAddClick() {
      if (this.selectedTrip.length == 0) {
        this.$showAlert('warning', 'No Trip Selected', 'Please select a trip to add the commission');
        return;
      }
      this.showDriverAttendantCommPopup = true;
      this.showDriverAttendantCommPopupTable = true;
      this.fixedCommCodeData = [];
      this.selectedFixedCommCode = [];
      setTimeout(() => {
        this.fixedCommCodeData = this.fixedCommCodeDataTemp;
      }, 500);
    }, 

    async saveJourneyDetails() {
      const updateComm = JSON.stringify(this.originalSelectedCommision) !== JSON.stringify(this.selectedCommision);
      const updateDriver = JSON.stringify(this.originalSelectedDriver) !== JSON.stringify(this.selectedDriver);
      const updateAttendant = JSON.stringify(this.originalSelectedAttendant) !== JSON.stringify(this.selectedAttendant);
      const updateAttendant2 = JSON.stringify(this.originalSelectedAttendant2) !== JSON.stringify(this.selectedAttendant2);
      const postData = {
        tmsjino: this.selectedJourney['Journey #'],
        commcode: updateComm ? this.selectedCommision['Com Code'] : '',
        driver: updateDriver ? this.selectedDriver['Driver Code'] : '',
        attendant: updateAttendant ? this.selectedAttendant['Attendant Code'] : '',
        attendant2: updateAttendant2 ? this.selectedAttendant2['Attendant Code'] : '',
        startmeter: this.startMeter,
        endmeter: this.endMeter,
        tollcost: this.tollCost,
        fuelcost: this.fuelCost
      };

      const result = await this.$apiCallV2('/TruckingMovementUpdate/TMSMovementUpdateUpdateDetails', postData);
      if (result[0]['Results'] != '0') {
        this.$showAlert('error', 'Update Journey Details Fail', `Unable to update journey details. ${result[0]['ErrMsg']}`);
      } else {
        this.journeyDetailsEditMode = false;
        await this.getJourneyDetails();
      }
    },

    async postTrip() {
      if (this.selectedTrip.length == 0) {
        this.$showAlert('warning', 'No Trip Selected', 'Please select at least 1 trip to post');
        return;
      }

      this.$fullscreenLoading('Posting Trip');
      const trips = this.selectedTrip.map(m => {
        return {
          ind: m['ind'],
          seqno: m['seqno'],
          cn: this.removeImgTag(m['Consignment #']),
          leg: m["Leg"],
          jobno: m['jobno'],
          journeyguid: m['journeyguid'],
          orderno: this.removeImgTag(m['#']),
          qty: m['Qty'],
          pkg: m['Pkg'],
          remarks: m['Remarks'],
          drvincentive: m['Drv Comm'], 
          drvotherinc: m['AdHoc Comm'],
          attnincentive: m['Attn Comm'],
          attnotherincentive: m['Attn AdHoc Comm'],
          vehiclerevenue: m['Trip Revenue'],
          attn2incentive: m['Attn2 Comm'],
          attn2otherinc: m['Attn2 AdHoc Comm'],
          billratecode: m['Bill Code'],
        };
      });

      const postData = {
        posttype: 'POST',
        tmsjino: this.selectedJourney['Journey #'],
        drivercode: this.journeyDetails['driver'],
        vehiclecode: this.journeyDetails['vehiclecode'],
        trips: trips, 
        lastupdate: '',
      };

      const result = await this.$apiCallV2('/TruckingMovementUpdate/TMSMovementUpdatePostTrip', postData);
      this.$fullscreenLoading();
      if (result[0]['Results'] != '0') {
        this.$showAlert('error', 'Post Trip Fail', `Unable to post trip. ${result[0]['ErrMsg']}`);
      } else {
        this.$showAlert('success', 'Post Trip Sucessful', `${result[0]['ErrMsg']}`);
        await this.getJourneyDetails();
      }
    },

    async undoPostTrip() {
      if (this.selectedTrip.length == 0) {
        this.$showAlert('warning', 'No Trip Selected', 'Please select at least 1 trip to undo post');
        return;
      }
      if (this.selectedTrip.every(s => s['ind'] != 'F')) {
        this.$showAlert('warning', 'Invalid Trip Selected', 'Please select only posted trip');
        return;
      }

      this.$fullscreenLoading('Undoing Post Trip');
      const trips = this.selectedTrip.map(m => {
        return {
          ind: m['ind'],
          seqno: m['seqno'],
          leg: m['Leg'],
          cn: this.removeImgTag(m['Consignment #']),
          jobno: m['jobno'],
          journeyguid: m['journeyguid'],
          orderno: this.removeImgTag(m['#'])
        };
      });

      const postData = {
        posttype: 'UNDO',
        tmsjino: this.selectedJourney['Journey #'],
        drivercode: this.journeyDetails['driver'],
        vehiclecode: this.journeyDetails['vehiclecode'],
        trips: trips, 
        lastupdate: '',
      };

      const result = await this.$apiCallV2('/TruckingMovementUpdate/TMSMovementUpdatePostTrip', postData);
      this.$fullscreenLoading();
      if (result[0]['Results'] != '0') {
        this.$showAlert('error', 'Undo Post Trip Fail', `Unable to undo post trip. ${result[0]['ErrMsg']}`);
      } else {
        this.$showAlert('success', 'Undo Post Trip Sucessful', `${result[0]['ErrMsg']}`);
        await this.getJourneyDetails();
      }
    },

    async pointStop(action) {
      if (this.selectedTrip.length == 0) {
        this.$showAlert('warning', 'No Trip Selected', `Please select at least 1 trip to ${action ? 'set' : 'remove'} as point stop`);
        return;
      }
      if ((action && this.selectedTrip.every(s => s['pointstop'] != '0')) || (!action && this.selectedTrip.every(s => s['pointstop'] != '1'))) {
        this.$showAlert('warning', 'Invalid Trip Selected', `Please select only trip that ${action ? 'is not' : 'is'} set as point stop`);
        return;
      }
      this.$fullscreenLoading(`${action ? 'Setting' : 'Removing'} Point Stop`);
      const setTrips = this.selectedTrip.map(m => {
        return {
          seqno: m['seqno'],
          leg: m['Leg'],
          cn: this.removeImgTag(m['Consignment #']),
          jobno: m['jobno'],
          journeyguid: m['journeyguid'],
          orderno: this.removeImgTag(m['#']),
          qty: m['Qty'],
          pkg: m['Pkg'],
          remarks: m['Remarks'],
          ind: m['ind'],
        };
      });

      const postData = {
        set: 'SET', //might not be needed
        tmsjino: this.selectedJourney['Journey #'],
        pointstop: action ? '1' : '0',
        settrips: setTrips
      };

      const result = await this.$apiCallV2('/TruckingMovementUpdate/TMSMovementUpdateSetPointStop', postData);
      this.$fullscreenLoading();
      if (result[0]['Results'] != '0') {
        this.$showAlert('error', `${action ? 'Set' : 'Remove'} Point Stop Fail`, `Unable to ${action ? 'set' : 'remove'} point stop. ${result[0]['ErrMsg']}`);
      } else {
        this.$showAlert('success', `${action ? 'Set' : 'Remove'} Point Stop Sucessful`, `${result[0]['ErrMsg']}`);
        await this.getJourneyDetails();
      }
    }, 

    async combineTrip(action) {
      if (this.selectedTrip.length == 0) {
        this.$showAlert('warning', 'No Trip Selected', `Please select at least 1 trip to ${action ? 'set' : 'remove'} as combine trip`);
        return;
      }
      if ((action && this.selectedTrip.every(s => s['Combine Trip #'] != '0')) || (!action && this.selectedTrip.every(s => s['Combine Trip #'] != '1'))) {
        this.$showAlert('warning', 'Invalid Trip Selected', `Please select only trip that ${action ? 'is not' : 'is'} set as combine trip`);
        return;
      }
      this.$fullscreenLoading(`${action ? 'Setting' : 'Removing'} Combine Trip`);
      const combinetrips = this.selectedTrip.map(m => {
        return  {
          seqno: m['seqno'],
          leg: m['Leg'],
          cn: this.removeImgTag(m['Consignment #']),
          jobno: m['jobno'],
          journeyguid: m['journeyguid'],
          orderno: this.removeImgTag(m['#']),
          qty: m['Qty'],
          pkg: m['Pkg'],
          remarks: m['Remarks'],
          ind: m['ind'],
        };
      });

      const postData = {
        tmsjino: this.selectedJourney['Journey #'],
        combinetrips : combinetrips,
        firstseqno: this.selectedTrip[0]['seqno'],
        combinetype: action ? 'COMBINE' : 'UNDO' //COMBINE, UNDO
      };

      const result = await this.$apiCallV2('/TruckingMovementUpdate/TMSMovementUpdateCombineTrip', postData);
      this.$fullscreenLoading();
      if (result[0]['Results'] != '0') {
        this.$showAlert('error', `${action ? 'Set' : 'Remove'} Combine Trip Fail`, `Unable to ${action ? 'set' : 'remove'} combine trip. ${result[0]['ErrMsg']}`);
      } else {
        this.$showAlert('success', `${action ? 'Set' : 'Remove'} Combine Trip Sucessful`, `${result[0]['ErrMsg']}`);
        await this.getJourneyDetails();
      }
    }, 

    removeImgTag(value) {
      return value.replace(/<img\b[^>]*>/, '');
    }
  },
  async mounted() {
    await this.sasControlFunction();
    await this.getDropdownData();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.Trucking-Movement-Update-Main {
  font-size: 12px;
  display: flex;
  padding: 10px 5px 10px 45px;

  > .left-container {
    border-radius: 5px;
    max-width: 200px;
    width: 100%;
    background-color: white;
    margin-right: 5px;
    height: 100%;
    transition: 0.3s;

    > .arrow-button {
      width: 100%;
      padding: 7px 4px 50px 0px;
      display: flex;
      justify-content: flex-end;

      > img {
        height: 30px;
        width: 30px;
        padding: 2px;
        z-index: 1;
        transform: scale(1);
        transition: 0.3s;
        cursor: pointer;

        &:hover {
          border-radius: 50%;
          background-color: rgba(0, 0, 0, 0.5);
          transition: 0.3 ease;
        }
      }
    }

    > .left-container-content {
      width: 100%;
      height: calc(100% - 320px);
      display: flex;
      flex-direction: column;
      padding: 5px;

      > button {
        width: 90%;
        margin: 0px 0px 5px 5px;
      }
    }

    > .left-container-bottom-content {
      height: 230px;
      padding: 5px;

      > .tab-header {
        display: flex;
        flex-direction: column;

        > .tab-box {
          border: 1px solid rgba(0, 0, 0, 0.3);
          text-align: center;
          padding: 10px 5px;
          cursor: pointer;
        }

        > .selected {
          border-width: 1px 5px 1px 1px;
          border-color: rgba(0, 0, 0, 0.3) #26b900 rgba(0, 0, 0, 0.3) rgba(0, 0, 0, 0.3);
        }
      }
    }
  }

  > .left-tab-close {
    max-width: 40px;
  }

  > .right-container {
    // border-radius: 5px;
    width: 100%;
    height: 100%;
    overflow: hidden;

    > .top-container {
      width: 100%;
      height: 100px;
      border-radius: 5px;
      background-color: white;
      display: flex;

      > .top-left-container {
        padding: 5px;
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 40%;

        > .details-content {
          display: flex;

          > .details-title {
            min-width: 80px;
            max-width: 80px;
          }

          > .details-colon {
            padding-right: 5px;
            padding-left: 5px;
          }
        }
      }

      > .top-middle-container {
        padding: 5px;
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 60%;

        > .comm-content {
          display: flex;

          > .comm-position {
            min-width: 80px;
            max-width: 80px;
          }
        }
      }
    }

    > .middle-container {
      display: flex;
      height: calc(100% - 340px);
      padding: 5px;
      border-radius: 5px;
      background-color: white;
      margin-top: 5px;
    }

    > .bottom-container {
      display: flex;
      height: 230px;
      width: 100%;
      border-radius: 5px;
      background-color: white;
      margin-top: 5px;

      > .bottom-left-container {
        width: 30%;
        padding: 5px;
      }

      > .bottom-middle-container {
        width: 40%;
        padding: 5px;
      }

      > .bottom-right-container {
        width: 60%;
        padding: 5px;
      }

      > .bottom-driver-attendant-commision {
        width: 70%;
        padding: 5px;
      }
    }
  }
}

.bottom-left-boxcontainer {
  width: 100%;
  display: flex;

  > .bottom-left-boxcontainer-left {
    width: 50%;
    padding-right: 3px;
  }

  > .bottom-left-boxcontainer-right {
    width: 50%;
    padding-left: 3px;

    > .boxcontainer-right-button {
      display: flex;
      justify-content: flex-end;

      > button {
        margin-left: 6px;
      }
    }
  }
}

.add-edit-delete-button {
  display: flex;
  justify-content: flex-end;

  > button {
    margin-left: 6px;
  }
}

.driver-attendant-table,
.journey-expenses-table,
.document-table {
  height: calc(100% - 30px);
}
</style>
